import { useDispatch } from "react-redux";
import { useState } from "react";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useCloneFlow from "hooks/useCloneFlow";
import {
  setFlowVersionToDelete,
  setDeleteFlowVersionDialogOpen,
  setChangeFlowVersionDialogOpen,
  setFlowVersionToUse,
  setFlowVersionsDialogOpen
} from "redux/actions/flowDesigner/flowsActionCreator";
import { useFlowPermissions } from "hooks/useFlowPermissions";

const VersionMenu = ({ version }) => {
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const [versionMenu, setVersionMenu] = useState(null);
  const { handleCloneFlow } = useCloneFlow();
  const isCurrentVersion = currentSavedFlow.current_version === version.version;
  const dispatch = useDispatch();
  const { canClone, canDelete, canEdit } = useFlowPermissions(currentSavedFlow);

  const handleVersionOpenMenu = (event) => {
    event.preventDefault();
    setVersionMenu(event.currentTarget);
  };

  const handleVersionCloseMenu = () => {
    setVersionMenu(null);
  };

  const handleClone = async () => {
    if (!canClone) return;
    handleCloneFlow(false, null, true, version);

    handleVersionCloseMenu();
  };

  const handleDeleteVersion = async () => {
    if (!canDelete) return;
    dispatch(setFlowVersionToDelete({ ...version }));
    dispatch(setDeleteFlowVersionDialogOpen(true));
    handleVersionCloseMenu();
  };

  const handleChangeFlowVersion = () => {
    if (!canEdit) return;
    dispatch(setFlowVersionToUse({ ...version, tenant_id: currentSavedFlow.tenant_id }));
    dispatch(setChangeFlowVersionDialogOpen(true));
    dispatch(setFlowVersionsDialogOpen(false));
    handleVersionCloseMenu();
  };

  const renderMenu = (state, close) => {
    return (
      <Menu
        anchorEl={state}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(state)}
        onClose={close}
        keepMounted
      >
        {!isCurrentVersion && (
          <MenuItem onClick={handleChangeFlowVersion} disabled={!canEdit}>
            Make current
          </MenuItem>
        )}
        <MenuItem onClick={handleClone} disabled={!canClone}>
          Clone
        </MenuItem>
        {!isCurrentVersion && (
          <MenuItem disabled={!canDelete} onClick={handleDeleteVersion}>
            Delete
          </MenuItem>
        )}
      </Menu>
    );
  };
  return (
    <>
      <Tooltip title="More Actions" placement="top">
        <Icon fontSize="default" onClick={handleVersionOpenMenu} sx={{ cursor: "pointer" }}>
          more_horiz_icon
        </Icon>
      </Tooltip>
      {renderMenu(versionMenu, handleVersionCloseMenu)}
    </>
  );
};

export default VersionMenu;
